/* eslint-disable */
const i18n = {
  "en-US": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Free Trial",
          "upgrade": "Upgrade"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Enter VAT or Tax identification number",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "de-DE": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Kostenloser Test",
          "upgrade": "Upgrade"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Umsatzsteuer-Identifikationsnummer eingeben",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "es-ES": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Prueba gratuita",
          "upgrade": "Actualizar"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Introduzca el IVA o el número de identificación fiscal",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "fr-FR": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Essai gratuit",
          "upgrade": "Surclasser"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Saisir le numéro de TVA ou le numéro fiscal",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "id-ID": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Uji Coba Gratis",
          "upgrade": "Tingkatkan"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Masukkan PPN atau Nomor Pokok Wajib Pajak",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "it-IT": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Prova gratuita",
          "upgrade": "Effettua l\u2019upgrade"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Inserisci la partita IVA o il codice fiscale",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "jp-JP": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB",
          "upgrade": "\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "VAT または納税者番号を入力",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "ko-KO": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\uBB34\uB8CC \uC2DC\uD5D8\uD310",
          "upgrade": "\uC5C5\uADF8\uB808\uC774\uB4DC"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "VAT 또는 납세자 식별번호 입력",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "nl-NL": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Gratis proefversie",
          "upgrade": "Upgraden"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Voer het btw- of fiscaal identificatienummer in",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "pl-PL": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Bezpłatna wersja testowa",
          "upgrade": "Zaktualizuj"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Wprowadź numer VAT lub NIP",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "pt-PT": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Teste gr\u00E1tis",
          "upgrade": "Fazer upgrade"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Digite o IVA ou número de identificação fiscal",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "ru-RU": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u043F\u0440\u043E\u0431\u043D\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F",
          "upgrade": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0441\u043E\u043A\u0438\u0439 \u043F\u043B\u0430\u043D"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Введите код плательщика НДС или идентификационный номер плательщика",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "tr-TR": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Ücretsiz Deneme",
          "upgrade": "Y\u00FCkselt"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "KDV veya Vergi kimlik numarasını girin",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "vi-VN": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "D\u00F9ng th\u1EED mi\u1EC5n ph\u00ED",
          "upgrade": "N\u00E2ng c\u1EA5p"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Nhập mã số thuế GTGT hoặc mã số thuế",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "zh-CN": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u514D\u8D39\u8BD5\u7528",
          "upgrade": "\u5347\u7EA7"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "输入增值税或纳税识别号",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "zh-TW": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u514D\u8CBB\u8A66\u7528",
          "upgrade": "\u5347\u7D1A"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "輸入增值稅 (VAT) 或稅務識別碼",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  },
  "sv-SE": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Gratis provperiod",
          "upgrade": "Uppgradera"
        }
      },
      "payment": {
        "tax": {
          "input_tax_place_holder": "Ange moms- eller skatteidentifikationsnummer",
          "tax_invalid_prompt": "This tax number is not valid"
        }
      }
    }
  }
}
export default i18n
